import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/base/BackToTop';
import useSeo from '@/hooks/useSeo';
import { faqs } from '@/mocks/faqs';
import { articles } from '@/mocks/articles';
import HeroSection from '@/pages/home/components/HeroSection';
import HotTicker from '@/pages/home/components/HotTicker';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import CategorySection from '@/pages/home/components/CategorySection';
import LatestSection from '@/pages/home/components/LatestSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';

export default function Home() {
  useSeo({
    title: '美日吃瓜 - 围观美日文化冲突名场面 | 争议言论 网络骂战 价值观碰撞',
    description:
      '美日吃瓜文化频道，专注围观美日文化冲突名场面。争议言论、网络骂战、价值观碰撞、政治正确翻车现场一应俱全，帮你看懂不同立场如何激烈交锋。',
    keywords: '美日吃瓜,美日文化冲突,争议言论,网络骂战,价值观碰撞,政治正确,翻车现场',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '美日吃瓜',
        url: 'https://hnqyjk.cn',
        description: '专注围观美日文化冲突的中文内容频道，整理争议言论、网络骂战与价值观碰撞案例。',
        email: 'contact@meirichigua.com',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '美日吃瓜',
        url: 'https://hnqyjk.cn',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://hnqyjk.cn/topics?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '美日吃瓜本周精选与最新观察',
        itemListElement: articles.slice(0, 8).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          url: `https://hnqyjk.cn/article/${item.slug}`,
        })),
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <HotTicker />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}